import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_authed/admin/settings")({
  component: SettingsPlaceholder,
})

function SettingsPlaceholder() {
  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
      <p className="mt-2 text-sm text-[color:var(--muted-foreground)]">
        Phase 0 placeholder. System-wide settings land in Phase 2.
      </p>
    </div>
  )
}
